import React, { useEffect, useRef, useState } from 'react';

const PipedriveForm: React.FC = () => {
    const formRef = useRef<HTMLDivElement>(null);
    const scriptLoadedRef = useRef(false);
    const [isFormLoaded, setIsFormLoaded] = useState(false);

    useEffect(() => {
        // Only load the script once
        if (scriptLoadedRef.current) return;

        const loadPipedriveScript = () => {
            // Check if script is already loaded
            if (document.querySelector('script[src="https://webforms.pipedrive.com/f/loader"]')) {
                scriptLoadedRef.current = true;
                checkFormLoaded();
                return;
            }

            const script = document.createElement('script');
            script.src = 'https://webforms.pipedrive.com/f/loader';
            script.async = true;
            script.onload = () => {
                scriptLoadedRef.current = true;
                console.log('Pipedrive script loaded successfully');
                // Start checking for form content
                checkFormLoaded();
            };
            script.onerror = () => {
                console.error('Failed to load Pipedrive script');
                setIsFormLoaded(true); // Hide loading on error
            };

            document.head.appendChild(script);
        };

        const checkFormLoaded = () => {
            const checkInterval = setInterval(() => {
                if (formRef.current) {
                    // Check if the form has been populated with content
                    const formContent = formRef.current.querySelector('iframe, form, .pd-form');
                    if (formContent) {
                        setIsFormLoaded(true);
                        clearInterval(checkInterval);
                    }
                }
            }, 500);

            // Fallback: hide loading after 10 seconds regardless
            setTimeout(() => {
                setIsFormLoaded(true);
                clearInterval(checkInterval);
            }, 10000);
        };

        // Small delay to ensure DOM is ready
        const timer = setTimeout(loadPipedriveScript, 100);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <div className="pipedrive-form-container">
            <div
                ref={formRef}
                className="pipedriveWebForms"
                data-pd-webforms="https://webforms.pipedrive.com/f/5VJst5PsyWhxUhIvZhBbOkTBKiGrTlOJcae5CWdGvcXYfgQncSsLwNPwpNO4W3es6f"
                style={{ minHeight: '400px' }}
            >
                {/* Loading state - only show when form is not loaded */}
                {!isFormLoaded && (
                    <div className="flex items-center justify-center h-64">
                        <div className="text-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
                            <p className="text-gray-600">Loading contact form...</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PipedriveForm;